module.exports = __webpack_public_path__ + "img/wtykp.3df0f332.png";